import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class resumenDiarioService {

    /******* QUERIES ******/
    async listarEstado() {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/importar-documentos?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ver(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/ver?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async xml(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cdr(filter) {
        const response = await axios
            .get(`${ERP}ventas/resumen-diario/cdr?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/
    async emitir(data) {
        const response = await axios
            .put(`${ERP}ventas/resumen-diario/emitir`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}ventas/resumen-diario/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async ticket(data) {
        const response = await axios
            .put(`${ERP}ventas/resumen-diario/ticket`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async registrar(data) {
        const response = await axios
            .post(`${ERP}ventas/resumen-diario`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}ventas/resumen-diario`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new resumenDiarioService();